
export const columnHeaderStyle = {
    textAlign: "left",
    fontWeight: "bold",
    font: "18px",
    borderRadius: "2px"
}

export const columnSubHeaderStyle = {
    textAlign: "left",
    fontWeight: "normal"
}

export const dataStyle = {
    textAlign: "left",
    padding: "3px",
}
